const isErrorWithLogs = error => error instanceof Error && 'logs' in error;

export { isErrorWithLogs };
//# sourceMappingURL=Program.mjs.map
